import styles from './index.less';
import arrowDownSvg from './images/arrow_down.svg';
import { history, useRouteProps } from 'umi';
import createRoutes from '@/routes/createRoutes'
import toolsRoutes from '@/routes/toolsRoutes';
import goToRoute from '@/utils/goToRoute'
import { Dispatch, SetStateAction, useMemo } from 'react';
import classNames from 'classnames';
import { eventEmitter, EventType } from '@/utils/emitter';
import { useBasePlatform,useStore } from '@/states/store';

const [{ routes }] = createRoutes
const [{routes:toolsRoute}]=toolsRoutes
const menu = routes.filter((o:any) => o.meta?.menu !== false&&o.meta?.showDropMenu!==false).map(item => ({ label: item.name, key: item.path, img: item.meta.img, subLabel: item.meta.subLabel,check:item.meta.check}))
const toolsMenu = toolsRoute.filter((o:any) => o.meta?.menu !== false&&o.meta?.showDropMenu!==false).map(item => ({ label: item.name, key: item.path, img: item.meta.img, subLabel: item.meta.subLabel,check:item.meta.check}))
const { UMI_ENV } = process.env

interface IProps {
	setShowMask: Dispatch<SetStateAction<boolean>>;
}
export default ({ setShowMask }: IProps) => {
  const { baseSnap } = useBasePlatform();
  const { userInfo } = useStore()

	const { path } = useRouteProps()
	// 是否需要会员校验
	const verifyMemberStatus = (label: string) => {
		return ['AI商详页', 'AI商品海报'].includes(label)
	} 
  
  const _menu = useMemo(() => {
    return menu.filter((_: any) => !baseSnap.oemInfos?.hideMenuPaths?.includes(_.key));
  }, [baseSnap.oemInfos]);
    
  const _toolsMenu = useMemo(() => {
    return toolsMenu.filter((_: any) => !baseSnap.oemInfos?.hideMenuPaths?.includes(_.key));
  }, [baseSnap.oemInfos]);
  
	return (
		<nav>
			<div
				className={path === '/' ? styles.active : ''}
				onClick={() => history.push('/')}
			>
				首页
			</div>
			<div
				className={styles.creativePlatform}
				onMouseEnter={() => setShowMask(true)}
				onMouseLeave={() => setShowMask(false)}
			>
				创作台
				<img src={arrowDownSvg} />
				<div className={styles.expandWrapper}>
					<ul>
						{
							_menu.map(item => {
								return <li key={item.key} onClick={() => {
									setShowMask(false)
                  goToRoute(item.key, (item.key.includes('marketing-poster') && userInfo?.specialInfo?.g3 === 'A') ? undefined : item.check)
								}}>
								
									<img src={item.img} alt="" />
									<div className={styles.customBox}>
										<p className={classNames(styles.label, {
											[styles.customLabel]: verifyMemberStatus(item.label)
										})}>{item.label}
										{/* {
											verifyMemberStatus(item.label) && <div className={styles.customTip}>会员专享</div>
										} */}
										</p>
										<p className={styles.subLabel}>{item.subLabel}</p>
									</div>
								
								</li>
							})
						}
					</ul>
				</div>
			</div>
			<div
				className={styles.creativePlatform}
				onMouseEnter={() => setShowMask(true)}
				onMouseLeave={() => setShowMask(false)}
			>
				AI工具
				<img src={arrowDownSvg} />
				<div className={styles.expandWrapper}>
					<ul>
						{
							_toolsMenu.map(item => {
								return <li key={item.key} onClick={() => {
									setShowMask(false)
									goToRoute(item.key,item.check)
								}}>
								
									<img src={item.img} alt="" />
									<div className={styles.customBox}>
										<p className={classNames(styles.label, {
											[styles.customLabel]: verifyMemberStatus(item.label)
										})}>{item.label}
										{
											verifyMemberStatus(item.label) && <div className={styles.customTip}>会员专享</div>
										}
										</p>
										<p className={styles.subLabel}>{item.subLabel}</p>
									</div>
								
								</li>
							})
						}
					</ul>
				</div>
			</div>
			<div
				className={path === '/my-creations' ? styles.active : ''}
				onClick={() => goToRoute('/my-creations')}
			>
				我的创作
			</div>
			{path === '/'&&<div
				// className={path === '/my-creations' ? styles.active : ''}
				className={styles.anli}
				onClick={()=>{
					eventEmitter.fire(EventType.homeScrollToModules)
				}}
			>
				营销案例
				<img src="https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/yingxiaoanli-xinnian@3x.png" alt="" />
			</div>}
			{UMI_ENV !== 'online' &&<div
				className={path === '/create/posterTemplate' ? styles.active : ''}
				onClick={() => goToRoute('/create/posterTemplate')}
			>
				海报模版
			</div>}
		</nav>
	);
};
